import React from 'react';
import { twMerge } from 'tailwind-merge';
import { Typography } from '@scale/scaleui';

export enum AutoFeedbackStatusState {
  NOT_RUN = 'Not Run',
  LOADING = 'Loading...',
  PASSED = 'Passed',
  REVIEW_ISSUES = 'Review Issues',
  OPTIONAL = 'Optional',
  ERROR = 'Error',
  RERUN_REQUIRED = 'Re-run Required',
}

interface AutoFeedbackStatusProps {
  className?: string;
  state: AutoFeedbackStatusState;
}

const AutoFeedbackStatusVariantMapping: { [key in AutoFeedbackStatusState]: string } = {
  [AutoFeedbackStatusState.NOT_RUN]: 'neutral',
  [AutoFeedbackStatusState.LOADING]: 'neutral',
  [AutoFeedbackStatusState.PASSED]: 'success',
  [AutoFeedbackStatusState.REVIEW_ISSUES]: 'danger',
  [AutoFeedbackStatusState.OPTIONAL]: 'warning',
  [AutoFeedbackStatusState.ERROR]: 'danger',
  [AutoFeedbackStatusState.RERUN_REQUIRED]: 'danger',
};

const AutoFeedbackStatusMessageMapping: { [key in AutoFeedbackStatusState]: string } = {
  [AutoFeedbackStatusState.NOT_RUN]:
    'Run the Chat Companion Feedback system by hitting the "Get Feedback" button. Note that it may not catch all mistakes, and you are responsible for ensuring the quality of your response.',
  [AutoFeedbackStatusState.LOADING]:
    'Loading the Chat Companion Feedback system. This may take up to 3 minutes.',
  [AutoFeedbackStatusState.PASSED]:
    'You have passed the Chat Companion Feedback system! You may now submit the task.',
  [AutoFeedbackStatusState.REVIEW_ISSUES]:
    'Please fix or disagree with the provided feedback items. Once finished, you may re-run the Chat Companion Feedback system or submit.',
  [AutoFeedbackStatusState.OPTIONAL]:
    'Chat Companion Feedback is optional for this task. You may submit the task when you feel it meets the quality guidelines of the task.',
  [AutoFeedbackStatusState.ERROR]:
    'There was an error running the Chat Companion Feedback system. Please try again. If the issue persists, you may choose to continue the task without getting feedback.',
  [AutoFeedbackStatusState.RERUN_REQUIRED]:
    'You have made changes to your response. Re-run the Chat Companion Feedback system to ensure you pass before submitting.',
};

function AutoFeedbackStatus({ className, state }: AutoFeedbackStatusProps) {
  return (
    <div className={twMerge('text-left rounded-md', className)}>
      <Typography.Paragraph1>
        <div className="font-bold flex gap-1 align-center text-md">
          Status:
          <span className={`ml-0.5 text-${AutoFeedbackStatusVariantMapping[state]}-400`}>
            {state}
          </span>
        </div>
        <div className="my-2 text-sm">{AutoFeedbackStatusMessageMapping[state]}</div>
      </Typography.Paragraph1>
    </div>
  );
}

export default AutoFeedbackStatus;
